<!-- <div class="hide-statements-container"> -->
  <!-- Основная строка с иконкой, текстом и toggle -->
  <div class="hide-statements-header">
    <app-item-icon
      icon="calendar"
      appearance="blue"
    ></app-item-icon>

    <h2 class="hide-statements-title">Не показывать выписки в ДБО</h2>

    <ion-toggle
      mode="ios"
      [checked]="isEnabled"
      [disabled]="isDisabled"
      (ionChange)="onToggleChange($any($event))"
      data-testid="hide-statements-toggle"
    ></ion-toggle>
  </div>

  <!-- Информационное сообщение, если запрет уже установлен -->
  <!-- <div class="hide-statements-info" *ngIf="isEnabled" data-testid="hide-statements-info">
    <ion-text color="medium">
      <p class="info-text">
        <ion-icon name="information-circle-outline"></ion-icon>
        Запрет на отображение в выписках установлен. Снятие возможно только в отделении банка.
      </p>
    </ion-text>
  </div> -->

  <!-- Предупреждение, если запрещены изменения -->
  <!-- <div class="hide-statements-warning" *ngIf="isChangeForbidden" data-testid="hide-statements-warning">
    <ion-text color="warning">
      <p class="warning-text">
        <ion-icon name="warning-outline"></ion-icon>
        По этому счету установлен запрет на изменение параметров
      </p>
    </ion-text>
  </div> -->
<!-- </div> -->
